const template = ` <div class="ngdialog-message">
        <div class="row">
          <div class="timeout-head">Do you want to continue your session? For security purposes you will be logged out in
                <span style="font-weight: bold">{{counter}}</span> seconds unless you continue.</div>
            <div class="center">
                <button class="timeout-continue-btn" ng-click="ok()">Ok</button>
                <button class="timeout-logout-btn" ng-click="logout()">Log out</button>
            </div>
        </div>
    </div>`;

class SessionTimeoutService {

    configureTimeout(){
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.showPopup.bind(this), (this.timeMinutes -1) * 60 * 1000);
    }
    
    constructor(ngDialog, $templateCache, systemService) {
            this.config = { attributes: true, childList: true, subtree: true };
            this.ngDialog = ngDialog;
            this.systemService = systemService;
            this.observer = new MutationObserver(this.configureTimeout.bind(this));
            $templateCache.put('session_timout_modal', template);
    }
    
    async start(token){
        this.timeMinutes = await this.systemService.getSettings(token, { select: { security: 1}})
            .then(({ security }) => security.sessionTimeoutMintues);
        this.configureTimeout();
        this.observer.observe(document.body, this.config);
    }
    
    stop(){
        this.observer.disconnect();
        clearTimeout(this.timeout);
    }
    
    showPopup(){
        const service = this;
        this.observer.disconnect();
        this.ngDialog.open({
            template: 'session_timout_modal',
            className: 'ngdialog-theme-default documentation-dialog',
            closeByDocument: false,
            closeByEscape: false,
            showClose: false,
            controller: function ($scope, $interval, ngDialog, userService, $localStorage, $sessionStorage, $state, errorHandler) {
                $scope.counter = 60;
                $interval(() => --$scope.counter, 1000);
                $scope.logout = () => {
                    userService.logout($localStorage['token']);
                    const coBrandedToken = $localStorage['coBrandedKEY'];
                    $localStorage.$reset();
                    $sessionStorage.$reset();
                    errorHandler.stop();
                    if(coBrandedToken){
                        $localStorage['coBrandedKEY'] = coBrandedToken;
                        $state.go('coBrandedLogin', { coBrandedKEY: coBrandedToken });
                    } else {
                        $state.go('login');
                    }

                }
                $scope.$watch('counter', (v) => !v && $scope.logout());
                $scope.ok = () => {
                    ngDialog.closeAll();
                    service.configureTimeout();
                    service.observer.observe(document.body, service.config);
                }
            }
        });
    }
}

(function (){
    angular.module('myApp').factory('sessionTimeout', ['$templateCache', 'ngDialog', 'systemService',
        function ($templateCache, ngDialog, systemService){
            return new SessionTimeoutService(ngDialog, $templateCache, systemService);
        }])
})();